var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooLi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#1275B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1186 9.69215C13.1186 10.6267 12.3085 11.3843 11.3093 11.3843C10.31 11.3843 9.5 10.6267 9.5 9.69215C9.5 8.7576 10.31 8 11.3093 8C12.3085 8 13.1186 8.7576 13.1186 9.69215Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74742 12.6281H12.8402V22H9.74742V12.6281Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8196 12.6281H14.7268V22H17.8196C17.8196 22 17.8196 19.0496 17.8196 17.2049C17.8196 16.0976 18.1977 14.9855 19.7062 14.9855C21.411 14.9855 21.4008 16.4345 21.3928 17.5571C21.3824 19.0244 21.4072 20.5219 21.4072 22H24.5V17.0537C24.4738 13.8954 23.6508 12.4401 20.9433 12.4401C19.3354 12.4401 18.3387 13.1701 17.8196 13.8305V12.6281Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooLi);
export default __webpack_public_path__ + "static/media/fooLi.4570c293e5d13e84a305e10d30db86d6.svg";
export { ForwardRef as ReactComponent };